module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.7.1-259.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.7.1.md
// module id = 702
// module chunks = 250